import React, { useEffect, useState } from 'react';
import CsDiagnostics from '../../models/CsDiagnostics';
import Multiselect from 'multiselect-react-dropdown';
import { toast } from 'react-toastify';
import axios from 'axios';
import { externalUrl } from '../../data/externalUrls';

const FormPartial = (props) => {
  const { csDiagnostics, setCsDiagnostics, setIsLoading } = props;
  let csDiagnosticsObj = new CsDiagnostics(csDiagnostics);
  // const [chargingStationsApi] = getApi('chargingStations');
  const [chargingStations, setChargingStations] = useState([])

  useEffect(() => {
    fetchChargingStations();
  }, [])

  const fetchChargingStations = async () => {
    try {
      // const response = await chargingStationsApi({ fields: 'options' }).unwrap();
      // setChargingStations(response.data.charging_stations.map(item => {return {...item, displayValue: `${item.id} - ${item.serial_no}`}} ));
      setIsLoading(true);
      await axios.get(`${externalUrl.flaskServiceUrl}/CS_Diagnostics/charging_stations`)
      .then((response) => {
        if (response?.data?.data && response?.data?.data.length > 0) {
          setChargingStations(response?.data?.data);
        } else {
          toast.warning("Charging stations are null or not found.")
        }
      })
      .catch(error => {
        toast.error(error?.message);
      });
    } catch (error) {
      toast.error(error.data?.message || 'Something went wrong !');
    } finally {
      setIsLoading(false);
    }
  }

  const onChargingStationSelect = (selectedList, selectedItem) => {
    csDiagnosticsObj['charging_station'].push(selectedItem);
    validateValue('charging_station');
    setCsDiagnostics(csDiagnosticsObj.toStateJson());
  }

  const onChargingStationRemove = (selectedList, removedItem) => {
    csDiagnosticsObj['charging_station'] = [];
    validateValue('charging_station');
    setCsDiagnostics(csDiagnosticsObj.toStateJson());
  }

  const validateValue = (field) => {
    if(field === 'start_date'){
      csDiagnosticsObj.validate('end_date');
    } else if(field === 'end_date'){
      csDiagnosticsObj.validate('start_date');
    } 
    csDiagnosticsObj.validate(field);
  }

  const changeValue = (field, value) => {
    csDiagnosticsObj[field] = value;
    validateValue(field);
    setCsDiagnostics(csDiagnosticsObj.toStateJson());
  }

  const selectedChargingStation = () => {
    return (chargingStations && chargingStations.length > 0) ? chargingStations.filter((cs_station) => cs_station.device_id === csDiagnostics.charging_station?.device_id) : [];
  }

  return <div className='row'>
    <div className="col mb-1">
      <label htmlFor='charging_station' className="form-label mb-1">Select Charging Station</label>
      <Multiselect
        id='charging_station'
        options={chargingStations}
        selectedValues={selectedChargingStation()}
        displayValue={'device_id'}
        avoidHighlightFirstOption={true}
        onSelect={onChargingStationSelect}
        onRemove={onChargingStationRemove}
        customArrow={true}
        placeholder='Select Charging Station'
        selectionLimit={1}
      />
      <div id="charging_station_help" className="form-text text-danger mt-0">
        {csDiagnosticsObj.errors.charging_station}
      </div>
    </div>
    <div className="col mb-1">
      <label htmlFor="start_date" className="form-label mb-1">Select Start Date and Time</label>
      <input
        id="start_date"
        type="datetime-local"
        step={1}
        value={csDiagnosticsObj.start_date}
        onChange={(e) => changeValue('start_date', e.target.value)}
        className="form-control form-control-sm font-size-12"
        aria-describedby="start_date_help"
      />
      <div id="start_date_help" className="form-text text-danger mt-0">
        {csDiagnosticsObj.errors.start_date}
      </div>
    </div>
    <div className="col mb-1">
      <label htmlFor="end_date" className="form-label mb-1">Select End Date and Time</label>
      <input
        id="end_date"
        type="datetime-local"
        step={1}
        value={csDiagnosticsObj.end_date}
        onChange={(e) => changeValue('end_date', e.target.value)}
        className="form-control form-control-sm font-size-12"
        aria-describedby="end_date_help"
      />
      <div id="end_date_help" className="form-text text-danger mt-0">
        {csDiagnosticsObj.errors.end_date}
      </div>
    </div>
  </div>
}

export default FormPartial;